/** Configuración de la torre, leída de variables de entorno de Vite. */

export const USAR_MOCK = import.meta.env.VITE_USAR_MOCK === 'true';
export const API_URL = (import.meta.env.VITE_API_URL ?? 'http://localhost:3000').replace(/\/+$/, '');

export const MAP_STYLE_OSCURO =
  import.meta.env.VITE_MAP_STYLE_URL || 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';
export const MAP_STYLE_CLARO =
  import.meta.env.VITE_MAP_STYLE_URL_CLARO || 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json';

export const ZONA_HORARIA = 'America/Argentina/Buenos_Aires';

/** Motivos del diálogo de justificación (los del diseño). */
export const MOTIVOS_JUSTIFICACION = [
  'Descanso autorizado',
  'Carga o descarga',
  'Condiciones climáticas',
  'Control en ruta',
  'Falla de comunicación',
  'Otro motivo',
] as const;

/** Mínimo de caracteres del motivo (lo exige la API: JustificarAlertaBody). */
export const MOTIVO_MIN_CARACTERES = 5;
